// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/distress-call-procedure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/distress-call-procedure/distress-call-procedure.js';

mount([g0]);
